const create_query_params = (filters) => {
	const params = new URLSearchParams();

	Object.keys(filters).forEach((key) => {
		if (filters[key] !== '') {
			params.append(key, filters[key]);
		}
	});

	return params.toString();
};

export default create_query_params;
